import { PK_COUNTRY, PK_COUNTRY_LIST_OF_ALLOWED_COUNTRIES } from 'constants/AccountInfo';

/**
 * Sorts countries alphabetically by name.
 * @param {Object[]} countries - List of countries
 * @returns {Object[]} alphabetically sorted list of countries
 * */
const getAlphabeticallySortedCountries = (countries) => {
    return countries.sort((a, b) => {
        const nameA = a.Name.toUpperCase();
        const nameB = b.Name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }

        if (nameA > nameB) {
            return 1;
        }

        return 0;
    });
};

/**
 * Sort countries.
 * @param {Object[]} countriesList - List of countries
 * @returns {Object[]} sorted list of countries
 * */
const sortCountries = (countriesList) => {
    const newCountryList = [];
    // Sort alphabetically.
    const sortCountries = getAlphabeticallySortedCountries(countriesList);
    // Put USA and Canada at the top of the list of countries.
    sortCountries.forEach((country) => {
        if (country.PK_Country === PK_COUNTRY.CANADA || country.PK_Country === PK_COUNTRY.USA) {
            newCountryList.unshift(country);
        } else {
            newCountryList.push(country);
        }
    });

    return newCountryList;
};

/**
 * Filters countries.
 * @param {Object[]} countriesList - List of countries
 * @returns {Object[]} filtered list of countries
 * */
const filterCountries = (countriesList) => {
    return countriesList.filter((country) => PK_COUNTRY_LIST_OF_ALLOWED_COUNTRIES.includes(country.PK_Country));
};

/**
 * Filter and sort countries
 * @param {Object[]} countriesList - List of countries
 * @returns {Object[]} filtered and sorted countries
 * */
export const filterAndSortCountries = (countriesList) => {
    const filteredCountries = filterCountries(countriesList);

    return sortCountries(filteredCountries);
};
